export enum CtaAttribute {
    TARGET = '_blank',
    REL = 'nofollow',
}

export const openInNewTab = (isTargetBlank: boolean) => (isTargetBlank ? CtaAttribute.TARGET : '');
